/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The result of an event.
 */
export const IssuedCardAuthorizationEventResult = {
  Approved: "approved",
  Declined: "declined",
  Processed: "processed",
} as const;
/**
 * The result of an event.
 */
export type IssuedCardAuthorizationEventResult = ClosedEnum<
  typeof IssuedCardAuthorizationEventResult
>;

/** @internal */
export const IssuedCardAuthorizationEventResult$inboundSchema: z.ZodNativeEnum<
  typeof IssuedCardAuthorizationEventResult
> = z.nativeEnum(IssuedCardAuthorizationEventResult);
/** @internal */
export const IssuedCardAuthorizationEventResult$outboundSchema: z.ZodNativeEnum<
  typeof IssuedCardAuthorizationEventResult
> = IssuedCardAuthorizationEventResult$inboundSchema;
